import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import SearchLegalManagement from './SearchLegalManagement'
import TableLealManagement from './TableLealManagement'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  deleteLitigation,
  downloadEcontractFile,
  downloadLitigationFileByPath,
  getLegalReportFile,
  getLegalReportSearch,
} from '../../redux/actions/legal'
import { DEFAULT_ERR_MSG, DELETE_ERR_MSG } from '../../constants/msgText'
import { DELETE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { downloadFile } from '../../utils/fileUtil'
import moment from 'moment'

export default function LegalManagementWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.formTable)
  const [formDisplayLists, setFormDisplayLists] = useState()
  const [deleteId, setDeleteId] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  // const [searchRequest, setSearchRequest] = useState()

  useEffect(() => {
    setFormDisplayLists(formSchema.formDisplayLists)

    // setSearchRequest(createSearchReq())
  }, [formSchema])

  // const createSearchReq = (data) => {
  //   return {
  //     lawType: data?.lawType || null,
  //     projectCode: data?.projectCode || null,
  //     docNumberOfPurchase: data?.docNumberOfPurchase || null,
  //     contractNumberRef: data?.contractNumberRef || null,
  //     lawStatus: data?.lawStatus || null,
  //     lawStatus: data?.lawStatus || null,
  //     projectName: data?.projectName || null,
  //     department: data?.department || null,
  //     pageNumber: 1,
  //     pageSize: 5,
  //   }
  // }

  const onSubmitSearchLegalManagement = (data) => {
    const request = {
      lawType: data?.lawType || null,
      projectCode: data?.projectCode || null,
      docNumberOfPurchase: data?.docNumberOfPurchase || null,
      contractNumberRef: data?.contractNumberRef || null,
      lawStatus: data?.lawStatus || null,
      lawStatus: data?.lawStatus || null,
      projectName: data?.projectName || null,
      department: data?.department || null,
      capital: data?.capital || null,
      startDueDate: data?.startDueDate ? moment(data?.startDueDate).format('YYYY/MM/DD') : null,
      endDueDate: data?.endDueDate ? moment(data?.endDueDate).format('YYYY/MM/DD') : null,
      pageNumber: 1,
      pageSize: 5,
    }

    handleGetSchema(request)
  }

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log('request : ', request)
      const _schema = await getLegalReportSearch(request)
      // console.log('response : ', _schema)

      if (_schema?.formTable) {
        setDataTable(_schema?.formTable)
      }
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    const request = {
      lawType: getValues('lawType'),
      projectCode: getValues('projectCode'),
      docNumberOfPurchase: getValues('docNumberOfPurchase'),
      contractNumberRef: getValues('contractNumberRef'),
      lawStatus: getValues('lawStatus'),
      lawStatus: getValues('lawStatus'),
      projectName: getValues('projectName'),
      department: getValues('department'),
      capital: getValues('capital'),
      startDueDate: getValues('startDueDate')
        ? moment(getValues('startDueDate')).format('YYYY/MM/DD')
        : null,
      endDueDate: getValues('endDueDate')
        ? moment(getValues('endDueDate')).format('YYYY/MM/DD')
        : null,

      pageNumber: pagenumber || 1,
      pageSize: pagesize || 5,
    }

    setPageNumber(pagenumber)
    setPageSize(pagesize)

    handleGetSchema(request)
  }

  const handelDelete = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await deleteLitigation(id)

      notification.open('success', {
        title: DELETE_SUCCESS_MSG,
        duration: 5000,
      })

      doneLoading()
      setIsLoading(false)

      handelGetSchemaOnReload(5, 1)
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DELETE_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCancelData = () => {
    const request = {
      lawType: null,
      projectCode: null,
      docNumberOfPurchase: null,
      contractNumberRef: null,
      lawStatus: null,
      lawStatus: null,
      projectName: null,
      department: null,
      capital: null,
      startDueDate: null,
      endDueDate: null,
      pageNumber: 1,
      pageSize: 5,
    }

    // onSubmitSearchLegalManagement({}, 'cancel_data')
    // setDataTable(null)
    // console.log('handleCancelData')
    handleGetSchema(request)
  }

  const onExport = (data) => {
    // console.log('handleOnClickExport ', data)

    const request = {
      lawType: data?.lawType || null,
      projectCode: data?.projectCode || null,
      docNumberOfPurchase: data?.docNumberOfPurchase || null,
      contractNumberRef: data?.contractNumberRef || null,
      lawStatus: data?.lawStatus || null,
      lawStatus: data?.lawStatus || null,
      projectName: data?.projectName || null,
      department: data?.department || null,
      capital: data?.capital || null,
      startDueDate: data.startDueDate ? moment(data.startDueDate).format('YYYY/MM/DD') : null,
      endDueDate: data.endDueDate ? moment(data.endDueDate).format('YYYY/MM/DD') : null,
    }

    // console.log('request ', request)
    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await getLegalReportFile(request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลรายการงานคดี`)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      //let errorJson = JSON.parse(await e.response.data.text())
      // console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  // const onDownloadTermidateFile = async (pathFile) => {
  //   startLoading()
  //   var file = await downloadLitigationFileByPath(pathFile)
  //   const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
  //   const link = document.createElement('a')
  //   link.href = url
  //   link.setAttribute('download', pathFile)
  //   document.body.appendChild(link)
  //   link.click()
  //   doneLoading()
  // }

  const onDownloadTermidate = async (code, econtractId, pathFile) => {
    if (econtractId) {
      handleDownloadEContractFile(code, econtractId)
    } else {
      onDownloadTermidateFile(pathFile)
    }
  }

  const onDownloadTermidateFile = async (pathFile) => {
    startLoading()

    try {
      var file = await downloadLitigationFileByPath(pathFile)
      var names = pathFile?.split('/')
      downloadFile(file, names[names.length - 1])
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDownloadEContractFile = async (code, econtractId) => {
    startLoading()
    setIsLoading(true)
    try {
      var fileName = `ลงนาม_หน้งสือบอกเลิก_${code}.pdf`

      var file = await downloadEcontractFile(econtractId)

      downloadFile(file, fileName)
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header || 'ค้นหาคดี'} bordered>
        {formDisplayLists && (
          <SearchLegalManagement
            schema={formDisplayLists}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmitData={handleSubmit(onSubmitSearchLegalManagement)}
            onCancelData={handleCancelData}
          />
        )}
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <div style={{ marginTop: 20 }}>
          <TableLealManagement
            schema={dataTable}
            Controller={Controller}
            control={control}
            pagination={true}
            loading={isLoading}
            onReload={handelGetSchemaOnReload}
            onDelete={setDeleteId}
            onExport={handleSubmit(onExport)}
            onDownload={onDownloadTermidate}
            pageNumber={pageNumber}
            pageSize={pageSize}
            enableEdit={!formSchema?.formTable?.disabled}
          />
        </div>
      )}

      <ConfirmWidget
        title={'ยืนยัน'}
        show={deleteId != undefined && deleteId != ''}
        detail={'ยืนยันการลบคดี'}
        onCancle={() => setDeleteId('')}
        onConfirm={() => {
          setDeleteId('')
          handelDelete(deleteId)
        }}
      />
    </>
  )
}
